import React from "react";
import {isMobile} from 'react-device-detect';
import {alpha, Breadcrumbs, Typography} from "@mui/material";
import {Link as RouterLink, useLocation,} from 'react-router-dom';
import Link from "@mui/material/Link";
import {breadcrumbNameMap} from "./Constants";
import {grey} from "@mui/material/colors";

export default function PageBreadcrumbs() {

    const location = useLocation();
    const brandBreadcrumbs = buildBrandBreadcrumbs(location.pathname);
    const pathnameList = location.pathname.split('/').filter((x) => x);

    function LinkRouter(props) {
        return <Link {...props} component={RouterLink}/>;
    }

    return (
        (brandBreadcrumbs || (pathnameList && pathnameList.length > 0)) &&
        <div className="hero inner-page">
            <div className="container">
                <div className="row align-items-end">

                    <Breadcrumbs aria-label="breadcrumb"
                                 sx={{ paddingBottom: 1, color: grey[900],
                                     ...( isMobile && {backgroundColor: alpha("#fff", 0.70)})}}>
                        <LinkRouter underline="hover" color="inherit" to="/">
                            Главная
                        </LinkRouter>
                        {brandBreadcrumbs
                            ? brandBreadcrumbs.map((crumb, index) => {
                                const last = index === brandBreadcrumbs.length - 1;
                                return last ? (
                                    <Typography sx={{color: grey[800]}} key={crumb.to}>
                                        {crumb.title}
                                    </Typography>
                                ) : (
                                    <LinkRouter underline="hover" color="inherit" to={crumb.to} key={crumb.to}>
                                        {crumb.title}
                                    </LinkRouter>
                                );
                            })
                            : pathnameList.map((value, index) => {
                                const last = index === pathnameList.length - 1;
                                const to = `/${pathnameList.slice(0, index + 1).join('/')}`;

                                return last ? (
                                    <Typography sx={{color: grey[800]}} key={to}>
                                        {breadcrumbNameMap[to]?.title}
                                    </Typography>
                                ) : (
                                    <LinkRouter underline="hover" color="inherit" to={to} key={to}>
                                        {breadcrumbNameMap[to]?.title}
                                    </LinkRouter>
                                );
                            })}
                    </Breadcrumbs>

                </div>
            </div>
        </div>
    );

    function buildBrandBreadcrumbs(pathname) {
        const match = pathname.match(/^\/(listing|catalog-moto|vehicleOrder\/catalog)\/brand\/([^/]+)$/);
        if (!match) {
            return null;
        }

        const basePath = match[1] === "vehicleOrder/catalog"
            ? "/vehicleOrder/catalog"
            : `/${match[1]}`;
        const brand = decodeBrandValue(match[2]);

        return [
            {to: basePath, title: breadcrumbNameMap[basePath]?.title || "Каталог"},
            {to: `${basePath}/brand/${match[2]}`, title: brand}
        ];
    }

    function decodeBrandValue(value) {
        try {
            return decodeURIComponent(value).replace(/\+/g, " ").trim().replace(/\s+/g, " ");
        } catch {
            return value.replace(/\+/g, " ").trim().replace(/\s+/g, " ");
        }
    }
}
